// extracted by mini-css-extract-plugin
export default {"cls1":"GrantsMarketingButton-cls1__b199192ed2c7417f8e54","cls2":"GrantsMarketingButton-cls2___c2f61d9123e38055e7b GrantsMarketingButton-cls1__b199192ed2c7417f8e54"};